export const isForeignCurrencyAccount = (asset) => asset?.productType === 'FOREIGN_CURRENCY_ACCOUNT';
export const assetCurrency = (asset) => asset?.productType === 'SWISS_SECOND_PILLAR' ? 'CHF' : 'EUR';
export const netAssetValue = (asset, scope) =>
    (Number(asset.latestValuationEur ?? asset.latestValuation?.amount ?? 0)
        - Number(asset.latestLiabilityEur ?? asset.latestLiability?.amount ?? 0))
    * (scope === 'household' ? 1 : Number(asset.personalSharePercent ?? 100) / 100);
